// creates a filter from a specification of the facet values, undefined values are skipped
// e.g.: facets = { name1: 'value1', name2: 'value2', name3: undefined, name4: null, name5: '' } => 'name1:value1 AND name2: AND name5:'
const createFilter = facets => Object.keys(facets).reduce((acc, curr) => (facets[curr] !== undefined ? `${acc}${acc ? ' AND ' : ''}${curr}:${facets[curr].trim()}` : acc), '')

export default createFilter



// WEBPACK FOOTER //
// ./src/dataservices/utilities/algoliaCreateFilter.js